export const useSafeWindow = () => {
  const _window: Ref<(Window & typeof globalThis) | undefined> = ref();

  onMounted(() => {
    if (typeof window === 'undefined') return;
    _window.value = window;
  });

  return { window: _window };
};
